// extracted by mini-css-extract-plugin
module.exports = {"locationWrapper":"FlagCountry_locationWrapper__165Y2","mb-6":"FlagCountry_mb-6__25A7U","mb-0":"FlagCountry_mb-0__q8z-n","locationText":"FlagCountry_locationText__wHdCu"};